import React, { useState, useEffect } from 'react';
import { assetUrl } from "../../utils/assetBase"; // Round TA-4
// Round PROFILE-1 — authenticated client for the DB-photo fallback fetch.
import api from "../../api";
import { useSelector, shallowEqual } from 'react-redux';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';

//import images
import avatar1 from "../../assets/images/users/avatar-1.jpg";

const ProfileDropdown = () => {

    const { user } = useSelector(state => ({
        user: state.Profile.user,
    }), shallowEqual);
    const [userDetails, setUserDetails] = useState({
        name: "Guest User",
        title: "User",

    });

    useEffect(() => {
        const authData = sessionStorage.getItem("authUser");
        if (authData) {
            const parsed = JSON.parse(authData);

            const name = parsed?.name || "Guest User";  // ✅ not parsed.data.name
            const title = parsed?.title || "User";

            setUserDetails({ name, title });
        }
    }, []);

    const [userName, setUserName] = useState("Admin");
    const [userImage, setUserImage] = useState("/uploads/user-dummy-img.jpg");
    useEffect(() => {
        const authUser = sessionStorage.getItem("authUser");

        if (authUser) {
            const obj = JSON.parse(authUser);
            let name = "Admin";
            let imagePath = "/uploads/user-dummy-img.jpg"; // fallback

            if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
                name = obj?.username || obj?.first_name || obj?.data?.first_name || "Admin";
                imagePath = obj?.imagePath || obj?.data?.imagePath || imagePath;
            } else if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
                name = obj?.email || "Admin";
                // firebase usually doesn't handle images this way
            } else {
                name = obj?.data?.name || obj?.name || "Admin";
                imagePath = obj?.data?.imagePath || obj?.imagePath || imagePath;
            }

            setUserName(name);
            setUserImage(assetUrl(imagePath)); // Round TA-4: env-driven host

            // Round PROFILE-1 — DB-photo fallback: many long-time employees
            // have a photo only in the empPhotos table (the org chart's
            // source, maintained via the HR menu) and no uploaded ImagePath
            // file — so the topbar showed a placeholder while the org chart
            // showed their face. When the account has no real ImagePath,
            // fetch the same DB photo the org chart uses (authenticated
            // endpoint added this round) and display it. Nothing hardcoded:
            // HR uploads/changes the photo → it appears here AND in the org
            // chart from the same row.
            const looksLikePlaceholder =
                !imagePath ||
                imagePath.includes("user-dummy-img") ||
                imagePath.includes("logofinal");
            const empId = obj?.data?.uid || obj?.uid;
            if (looksLikePlaceholder && empId) {
                let objectUrl = null;
                api.get(`/registration/employee-photo/${encodeURIComponent(String(empId).trim())}`,
                        { responseType: "blob" })
                    .then((res) => {
                        if (res?.data instanceof Blob && res.data.size > 0) {
                            objectUrl = URL.createObjectURL(res.data);
                            setUserImage(objectUrl);
                        }
                    })
                    .catch(() => { /* no DB photo either — keep the placeholder */ });
                return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
            }
        }
    }, []);



    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn shadow-none">
                    <span className="d-flex align-items-center">
                        <img className="rounded-circle header-profile-user" src={userImage}
                            alt="Header Avatar" />

                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">

                    {/* <h6 className="dropdown-header">Welcome {userDetails.name}!</h6> */}
                    <span className="dropdown-header">
                        <span className="d-none d-xl-block ms-1 fw-medium user-name-text8">{userDetails.name}</span>
                        <span className="d-none d-xl-block ms-1 fw-medium user-name-text">{userDetails.title}</span>
                    </span>

                    {/* Batch FE-P10: Phase 3 self-service profile (Address/Phone/Emergency).
                        Routes through ProfileUpdateController POST /api/profile/me/update.
                        Kept above the legacy "Profile" link (which goes to the
                        username-change-only page) so users land on the self-service
                        page by default. */}
                    <DropdownItem href={process.env.PUBLIC_URL + "/profile/me"}>
                        <i className="mdi mdi-account-edit-outline text-muted fs-16 align-middle me-1"></i>
                        <span className="align-middle">My Profile</span>
                    </DropdownItem>

                    {/* HR Round 5 / Issue 8: the second "Profile" item (which opened
                        the Velzon template stub at /profile) is removed — one profile,
                        one page. /profile itself now redirects to /profile/me, so any
                        old link still lands correctly. */}
                    {/* <DropdownItem href={process.env.PUBLIC_URL + "/apps-chat"}><i
                        className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Messages</span></DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "#"}><i
                        className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Taskboard</span></DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "/pages-faqs"}><i
                        className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Help</span></DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem href={process.env.PUBLIC_URL + "/pages-profile"}><i
                        className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Balance : <b>$5971.67</b></span></DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "/pages-profile-settings"}><span
                        className="badge bg-soft-success text-success mt-1 float-end">New</span><i
                            className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle">Settings</span></DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "/auth-lockscreen-basic"}><i
                        className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Lock screen</span></DropdownItem> */}
                    <DropdownItem href={process.env.PUBLIC_URL + "/logout"}><i
                        className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle" data-key="t-logout">Logout</span></DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;
